import React from 'react';
import { 
  Box, 
  Typography, 
  ListItemButton, 
  ListItemText,
  Paper,
  IconButton,
  List
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useHistory, useLocation, Route, Switch } from 'react-router-dom';
import UserManagement from './UserManagement';
import ProfilePage from './ProfilePage';
import PasswordPage from './PasswordPage';
import { Redirect } from 'react-router-dom';
import axios from "axios";
import { USER_URLS } from "../config/urls";
import { useEffect, useState } from "react";

const SettingsPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [user, setUser] = useState({
    name: "",
    role: "",
    initials: ""
  });

  const userRole = user?.role || 'User';



  const menuItems = [
    { title: 'Profile', path: '/settings/profile' },
    { title: 'Password', path: '/settings/password' },
    ...(userRole === 'Admin' || userRole === 'Super Admin'
      ? [{ title: 'User Management', path: '/settings/user-management' }]
      : [])
  ];
  
  useEffect(() => {
    const fetchUserData = () => {
      const token = localStorage.getItem('token');
      
      axios.get(USER_URLS.getMe, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        const userData = response.data;
  
        
        // Update user state with data from API
        setUser({
          name: userData.first_name + ' '+userData.last_name,
          role: userData.role,
        });
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });
    };
    
    fetchUserData();
  }, []);

  return (
    <Box sx={{ display: 'flex', height: 'calc(100vh - 48px)', bgcolor: '#f5f5f5' }}>
      {/* Left Sidebar - Always visible */}
      <Paper 
        elevation={0} 
        sx={{ 
          width: 250,
          borderRight: '1px solid #e0e0e0',
          bgcolor: 'white',
          borderRadius: 0
        }}
      >
        {/* Header */}
        <Box sx={{ 
          p: 2, 
          display: 'flex', 
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0'
        }}>
          <IconButton 
            size="small" 
            onClick={() => history.push('/explore')}
            sx={{ mr: 1 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" sx={{ fontSize: 18, fontWeight: 500 }}>
            Settings
          </Typography>
        </Box>

        {/* Navigation List */}
        <List sx={{ pt: 0 }}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.title}
              selected={location.pathname === item.path}
              onClick={() => history.push(item.path)}
              sx={{
                py: 1.5,
                '&.Mui-selected': {
                  bgcolor: 'transparent',
                  '& .MuiListItemText-primary': {
                    color: '#2196f3',
                    fontWeight: 500
                  }
                },
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <ListItemText 
                primary={item.title}
                primaryTypographyProps={{
                  fontSize: 15,
                  color: location.pathname === item.path ? '#2196f3' : '#666'
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>

      {/* Main Content Area - Renders different components based on route */}
      <Box sx={{ 
        flex: 1, 
        overflow: 'auto'
      }}>
        <Switch>
          <Route path="/settings/profile" component={ProfilePage} />
          <Route path="/settings/password" component={PasswordPage} />
          <Route path="/settings/user-management" render={() => (
  userRole === 'Admin' || userRole === 'Super Admin'
    ? <UserManagement />
    : <Redirect to="/settings/profile" />
)} />

          {/* Add other routes for different settings pages */}
          <Route path="/settings" exact>
            <Box sx={{ p: 3 }}>
              <Typography>Select a settings option</Typography>
            </Box>
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};

export default SettingsPage;